import cleanedFilename from '~/util/cleanedFilename';

export default {
  OVERVIEW_HEADER: `${cleanedFilename(__filename)}-overview-header`,
};
